"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowPasswordToggle = void 0;
var ShowPasswordToggle = (function () {
    function ShowPasswordToggle(element) {
        this.$button = $("<button type=\"button\" class=\"btn-toggle-pass\" tabindex=\"-1\"><i class=\"fa fa-eye\"></i></button>");
        this.$element = element;
        this.init();
    }
    ShowPasswordToggle.prototype.init = function () {
        this.$element.next().after(this.$button);
        this.$button.on('click touchstart', this.handleClick.bind(this));
    };
    ShowPasswordToggle.prototype.handleClick = function () {
        var type = this.$element.attr('type');
        type = type === 'password' ? 'text' : 'password';
        this.$element.attr('type', type);
        this.$button.toggleClass('active');
    };
    return ShowPasswordToggle;
}());
exports.ShowPasswordToggle = ShowPasswordToggle;
(function ($) {
    $(document).ready(function () {
        $("[type=password]").each(function () {
            new ShowPasswordToggle($(this));
        });
    });
})(jQuery);
